<template>
    <div class="guided-scip-regulation-content">
        <BFormGroup
            :label="translate('Component(Label):scip-number', 'SCIP number')"
            label-for="guided-regulation-scip-number"
            class="mb-0"
        >
            <BFormInput
                id="guided-regulation-scip-number"
                :value="scipNumber"
                :state="numberViolationMessages.length ? false : null"
                @input="updateScipNumber"
            />
            <BFormInvalidFeedback
                v-for="(message, index) in numberViolationMessages"
                :key="`scip-number-violation-${index}`"
                force-show
            >
                {{ message }}
            </BFormInvalidFeedback>
        </BFormGroup>
    </div>
</template>

<script>
import {
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
} from 'bootstrap-vue'

export default {
    name: 'GuidedScipRegulationContent',
    components: {
        BFormGroup,
        BFormInput,
        BFormInvalidFeedback,
    },
    props: {
        scipInformation: {
            type: Object,
            default: null,
        },
        violations: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        scipNumber() {
            return this.scipInformation && this.scipInformation.scipNumber
                ? this.scipInformation.scipNumber
                : ''
        },
        numberViolationMessages() {
            return this.violations
                .filter(violation => violation
                    && String(violation.path || '').endsWith('[scipInformation][scipNumber]'))
                .map(violation => violation.message)
                .filter(Boolean)
        },
    },
    methods: {
        translate(key, fallback) {
            const translation = this.$t(key)

            return translation && translation !== key ? translation : fallback
        },
        updateScipNumber(value) {
            const normalized = typeof value === 'string' ? value : ''

            this.$emit('update-scip-information', normalized.trim().length
                ? {
                    ...(this.scipInformation || {}),
                    scipNumber: normalized,
                }
                : null)
        },
    },
}
</script>
